module.exports = __webpack_public_path__ + "static/media/02_profile_picture.a1e3cfde.png";